var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowViolet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16052 8.47029H13.6972M13.6972 8.47029L9.08743 3.86047M13.6972 8.47029L9.08743 13.0801",
    stroke: "url(#paint0_linear_501_731)",
    strokeWidth: 1.31709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_731",
    x1: 8.42888,
    y1: 3.86047,
    x2: 8.42888,
    y2: 13.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowViolet);
export default __webpack_public_path__ + "static/media/arrow-violet.cbd13a81e2c7cf20a6c620375931af29.svg";
export { ForwardRef as ReactComponent };